import type { PropsWithChildren } from 'react';
import { useEffect, useMemo } from 'react';
import { setUser } from '@sentry/react';

import { useAuth } from '@izimi/auth';
import { TrackingProvider } from '@izimi/components';
import { useModules } from '@izimi/modules';
import config from 'core/config';
import { useConfigurationLinks } from 'core/modules/public';

export const CitizenTrackingProvider = ({ children }: PropsWithChildren) => {
  const { cookieUrl } = useConfigurationLinks();
  const { user } = useAuth();
  const {
    public: { useWebConfiguration },
  } = useModules();
  const { configuration } = useWebConfiguration();

  useEffect(() => {
    if (user?.profile.id) {
      setUser({ id: user.profile.id });
    }
  }, [user?.profile.id]);

  const tracking = useMemo(() => configuration?.analytics.id ?
    {
      siteId: configuration?.analytics.id,
      url: config.apiUrl,
      trackerUrl: `${config.apiUrl}/matomo/piwik.php`,
      srcUrl: `${config.apiUrl}/matomo/piwik.js`,
    } :
    null, [configuration?.analytics.id]);

  return (
    <TrackingProvider config={tracking} cookieUrl={cookieUrl}>
      {children}
    </TrackingProvider>
  );
};
